export const API = "https://api-nyelhwmifq-el.a.run.app";

// export const API = "http://localhost:5001/megjack-eb778/asia-south1/api";

export const APP_NAME = "Megjack";
